import { ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-candidate-home',
  templateUrl: './candidate-home.component.html',
  styleUrls: ['./candidate-home.component.scss']
})
export class CandidateHomeComponent implements OnInit, OnChanges {

  sections = [];
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
    private _questionnaire: QuestionnaireService,
    private router: Router,
    public dialog: MatDialog) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit
  }

  ngOnInit(): void {
    this._questionnaire.getexams({}).subscribe(resolve => {
      this.sections = resolve;
    })
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onSelect(section: any) {
    this.router.navigate(['homecandidate/test/', section.id, section.name])
  }

  openDialog() {
    sessionStorage.clear()
    this.router.navigate(['/apply'])
  }



}

